import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { News } from 'src/app/models/obs/news';
import { urlNew } from 'src/app/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private http: HttpClient) { }

  getAllNews() {
    return this.http.get(`${urlNew}/get-all-n`);
  }

  getNewsByPage(page: number) {
    return this.http.get(`${urlNew}/get-by-page/${page}`);
  }

  getAllNewsAdm() {
    return this.http.get(`${urlNew}/get-all-n-adm`);
  }

  getAllEv() {
    return this.http.get(`${urlNew}/get-all-e`);
  }

  getAllEvAdm() {
    return this.http.get(`${urlNew}/get-all-e-adm`);
  }

  getOne(id: string) {
    return this.http.get(`${urlNew}/get-one/${id}`);
  }

  getLastNews() {
    return this.http.get(`${urlNew}/get-last-n`);
  }

  getLastEv() {
    return this.http.get(`${urlNew}/get-last-e`);
  }

  createNews(data: News): Observable<News> {
    return this.http.post(`${urlNew}/create-n`, data);
  }

  createEv(data: News): Observable<News> {
    return this.http.post(`${urlNew}/create-e`, data);
  }

  updateNews(id: string, data: News): Observable<News> {
    return this.http.put(`${urlNew}/update-n/${id}`, data);
  }

  updateEv(id: string, data: News): Observable<News> {
    return this.http.put(`${urlNew}/update-e/${id}`, data);
  }

  delete(id: string) {
    return this.http.delete(`${urlNew}/delete/${id}`);
  }

  //Obtenemos las 3 noticias relacionadas por fioha visualilzada
  getRelatedNewsForTier3(data: any) {
    return this.http.post(`${urlNew}/get-related-nt`, data);
  }

  //Obtenemos las 3 noticias relacionadas por fioha visualilzada
  getRelatedNews(data: any) {
    return this.http.post(`${urlNew}/get-related-n`, data);
  }
  //Obtenemos los 3 eventos relacionadas por fioha visualilzada
  getRelatedEvent(data: any) {
    return this.http.post(`${urlNew}/get-related-e`, data);
  }
  //conseguir el tipo de ficha segun sea new o event
  getTypeNewOrEvent(id: string) {
    return this.http.get(`${urlNew}/get-type/${id}`);
  }
}
